<template>
    <div class="list container-subscription">
        <div class="subscription_container" v-if="isLoaded && isHaveItem">
            <SubscriptionItem
                v-for="(campaign, k) in campaigns"
                class="col-6 campaign-item"
                :key="k"
                :index="k"
                :campaign="campaign"
            />
        </div>
        <div v-if="isLoaded && !isHaveItem" class="text-center">
            พบกันเร็วๆนี้
        </div>
    </div>
</template>
<script>
// component
import SubscriptionItem from "@/module/Menu/component/SubscriptionItem.vue"
// helper
import Account from "@/helper/AccountHelper.js";
//service
import BzbsCategory from "@/core/Campaign/service/BzbsCategory.js";

export default {
    name: "SubscriptionList",
    components: {
        SubscriptionItem
    },
    props: {
        categoryConfig: Object,
    },
    data: function() {
        return {
            campaigns: [],
            isLoaded: false,
            isHaveItem: true,    
        };
    },
    created: function() {
        this.getList();
    },
    methods: {
        getList() {
            return new Promise((resolve) => {
                var categoryParam = this.categoryConfig.getParams();

                var token = Account.getToken();
                BzbsCategory.apiGetCategory(token, categoryParam).subscribe(
                    categories => {
                        for (var category of categories) {
                            this.campaigns.push(category);
                        }

                        this.isLoaded = true;
                        this.isHaveItem =
                            this.campaigns.length > 0 ? true : false;

                        resolve(this.campaigns)
                    },
                    err => {
                        this.isLoaded = true;
                        this.isHaveItem = false;
                        console.log(err);
                    }
                );
            });
        },
        showLoading: function() {
            if (this.isLoading) return true;

            this.toggleLoading(true);

            return false;
        },
        hideLoading: function() {
            this.toggleLoading(false);
        },
        toggleLoading: function(isLoading) {
            this.$emit("toggleLoading", isLoading);
        },
        resetLoaded: function() {
            this.campaigns = [];
            this.isLoaded = false;
            this.isHaveItem = false;
        }
    }
};
</script>
<style lang="scss" scoped>
@import "@/style/base/baseDisplay.scss";
@import "@/style/historypoint.scss";
.subscription_container{
    padding: 0px 20px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
}
</style>
